/**
 * Scroll to top button functionality
 */

function scrollCalc(scrollButton) {
  if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
    scrollButton.classList.remove('scroll-to-top--hidden');
  } else {
    scrollButton.classList.add('scroll-to-top--hidden');
  }
}

// when the user clicks on the button, scroll to the top of the document
function scrollToTop(e) {
  e.preventDefault();
  window.scroll({ top: 0, left: 0, behavior: 'smooth' }); // the smoothscroll-polyfill node_module used for smooth scroll in IE and Safari
}
